import { DependencyList, useEffect, useRef } from 'react'

/**
 * same as useEffect except it doesn't run on mount, only when deps update
 *
 * @param effect
 * @param deps
 */
export const useEffectOnlyAfterMount = (
    effect: () => void,
    deps: DependencyList
) => {
    const isMounted = useRef(false)
    // react can't determine if we are missing dependencies here so it will always throw a lint error but we are just wrapping useEffect essentially
    /* eslint-disable react-hooks/exhaustive-deps */
    useEffect(() => {
        if (isMounted.current) return effect()
        else isMounted.current = true
    }, deps)

    // reset on unmount; in React 18, components can mount again
    useEffect(
        () => () => {
            isMounted.current = false
        },
        []
    )
}
